// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mde[data-v-3062f9c6] {\n  margin-bottom: -16px;\n}", ""]);
// Exports
module.exports = exports;
